"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M12.44,14.41,18,8.82a4.53,4.53,0,0,0,5.61-6.06.5.5,0,0,0-.36-.3.51.51,0,0,0-.45.13l-2,1.91H19.54V3.19l1.87-2a.5.5,0,0,0-.17-.8,4.51,4.51,0,0,0-5,1A4.58,4.58,0,0,0,15.18,6L9.59,11.56h0L6,15.18a4.5,4.5,0,0,0-5.62,6,.5.5,0,0,0,.8.18l2-1.75H4.44V20.9L2.65,22.84a.5.5,0,0,0,.17.81,4.48,4.48,0,0,0,4.93-1A4.57,4.57,0,0,0,8.83,18l3.61-3.62",
    fill: "#024965"
  }));
};

exports["default"] = _default;